import React, { useContext, useEffect, useState } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  CardBody,
  Card,
  ModalFooter,
} from "reactstrap"
import { DataContext } from "../../context/dataContext"
import apiHandler from "../../common/config/apiHandler"
import toast from "react-hot-toast"
import { inComingCancelBooking } from "../../common/config/socket.service"
import Loader from "../../components/Loader/loader"
import { useNavigate } from "react-router-dom"

const CancelBookingModal = ({ isOpen, toggle, setActiveTab }) => {
  const {
    bookingDetails,
    fetchSubscribeKey,
    subscribeKey,
    handleFetchBookingDetails,
  } = useContext(DataContext)
 const navigate = useNavigate()
  const [cancelBookingData, setCancelBookingData] = useState({})
  const [refundAmount, setRefundAmount] = useState(0)
  const [checkbox, setCheckbox] = useState({
    company_email: true,
    customer_email: true,
  })
  const [differenceAmount, setDifferenceAmount] = useState(0)
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [transferA2z, setTransferA2z] = useState(false)
  const [refundOption, setRefundOption] = useState("")
  const [instructions, setInstructions] = useState("")
  const [loading, setLoading] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [modalBtnLoader, setModalBtnLoader] = useState(false)
  const [showTransferConfirmation, setShowTransferConfirmation] =
    useState(false)

  const [apiResponse, setApiResponse] = useState(null)
  const [totalAmount, setTotalAmount] = useState(0)
  const [approveA2z, setApproveA2z] = useState(true)
  useEffect(() => {
    if (bookingDetails?.bookingDetails?.[0]?.company?.sku_tag == "a2z") {
      setTransferA2z(true)
      GetA2ZApiTransfer()
    } else {
      setApproveA2z(false)
      setTransferA2z(false)
    }
  }, [])

  const handleCheckboxChange = e => {
    const { name, type, value } = e.target
    setCheckbox(prevData => ({
      ...prevData,
      [name]:
        type === "checkbox" ? (prevData[name] === "1" ? "0" : "1") : value,
    }))
  }
  useEffect(() => {
    const currentDetail = bookingDetails?.bookingDetails?.find(
      detail => detail?.is_current === true || detail?.is_current === 1
    )

    if (currentDetail) {
      setCancelBookingData(currentDetail)
    }
    fetchSubscribeKey()
  }, [bookingDetails])

  useEffect(() => {
    const paidAmount =
      (parseFloat(cancelBookingData?.payment?.amount) || 0) +
      (parseFloat(cancelBookingData?.payment?.cancellation_charges) || 0) +
      (parseFloat(cancelBookingData?.payment?.sms_charges) || 0) +
      (parseFloat(cancelBookingData?.payment?.levy_charges) || 0) +
      (parseFloat(cancelBookingData?.payment?.valet_charges) || 0) +
      (parseFloat(cancelBookingData?.payment?.admin_charges) || 0) +
      (parseFloat(cancelBookingData?.payment?.extra_charges) || 0) -
      (parseFloat(cancelBookingData?.payment?.discount) || 0)

    const diffAmount = bookingDetails?.site?.cancellation_fee

    setDifferenceAmount(diffAmount)
    setRefundAmount(paidAmount - diffAmount)
  }, [cancelBookingData])

  useEffect(() => {
    const paidAmount =
      (parseFloat(cancelBookingData?.payment?.amount) || 0) +
      (parseFloat(cancelBookingData?.payment?.cancellation_charges) || 0) +
      (parseFloat(cancelBookingData?.payment?.sms_charges) || 0) +
      (parseFloat(cancelBookingData?.payment?.levy_charges) || 0) +
      (parseFloat(cancelBookingData?.payment?.valet_charges) || 0) +
      (parseFloat(cancelBookingData?.payment?.admin_charges) || 0) +
      (parseFloat(cancelBookingData?.payment?.extra_charges) || 0) -
      (parseFloat(cancelBookingData?.payment?.discount) || 0)

    setRefundAmount(paidAmount - differenceAmount)
  }, [differenceAmount, cancelBookingData])

  const GetA2ZApiTransfer = async () => {
    const data = {
      key: subscribeKey,
      api_tag: bookingDetails?.bookingDetails?.[0]?.company?.sku_tag,
      booking_id: bookingDetails?.id,
    }
    setLoading(true)
    try {
      const response = await apiHandler({
        endpoint2: "/stripe/paymentIntent/showTransfer",
        method: "POST",
        data: data,
      })

      if (response.response_code === 200) {
        setApiResponse(response?.data)
        setTotalAmount(response?.data?.reduce((sum, t) => sum + t.amount, 0))
        const allReversed = response?.data?.every(item => item.reversed == true)
        if (allReversed) {
          setApproveA2z(false)
        }
        setLoading(false)
      } else {
        toast.error(response?.errors)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)

      console.error("Error:", error)
      toast.error("An error occurred")
    } finally {
      setLoading(false)

      setShowConfirmation(false)
      setLoading(false)
    }
  }
  const HandleA2ZApiTransfer = async () => {
    const data = {
      key: subscribeKey,
      api_tag: bookingDetails?.bookingDetails?.[0]?.company?.sku_tag,
      booking_id: bookingDetails?.id,
    }
    setBtnLoading(true)
    try {
      const response = await apiHandler({
        endpoint2: "/stripe/paymentIntent/reverseAllTransfer",
        method: "POST",
        data: data,
      })

      if (response.response_code === 200) {
        setBtnLoading(false)
        setApproveA2z(false)
        
      } else {
        toast.error(response?.errors)
        setBtnLoading(false)
      }
    } catch (error) {
      setBtnLoading(false)

      console.error("Error:", error)
      toast.error("An error occurred")
    } finally {
      setShowConfirmation(false)
      setBtnLoading(false)
    }
  }

  
  const handleSubmit = e => {
    e.preventDefault()
    if (refundOption != "") {
      setShowConfirmation(true)
    } else {
      toast.error("Please select refund option")
      return
    }
  }

  const user = JSON.parse(localStorage?.getItem("user"))

  const confirmCancellation = async () => {
    setModalBtnLoader(true)
    const data = {
      key: subscribeKey,
      reference_no: bookingDetails?.reference_no,
      refunded_amount: refundAmount.toFixed(2),
      type: refundOption,
      instructions: instructions,
      user_id: String(user?.id),
      company_email: checkbox?.company_email ? "1" : "0",
      customer_email: checkbox?.customer_email ? "1" : "0",
    }

    try {
      const response = await apiHandler({
        endpoint2: "/crsbookings/cancel",
        method: "POST",
        data: data,
      })

  

      if (response?.response_code == 200) {
        inComingCancelBooking({
          data: { reference_no: bookingDetails?.reference_no },
          token: subscribeKey,
        })
        navigate("/allBookings");
        setTimeout(() => {
          window.location.reload();
        }, 100); 
        handleFetchBookingDetails(bookingDetails?.id)

        toast.success("Cancellation successful")
        setModalBtnLoader(false)
      } else {
        toast.error(response?.errors)
        setModalBtnLoader(false)
      }
    } catch (error) {
      setModalBtnLoader(false)
      console.error("Error:", error)
    } finally {
      setShowConfirmation(false)
    }
  }

  const calculateTimeLeft = departureDate => {
    const now = new Date()
    const departure = new Date(departureDate)
    const difference = departure - now

    if (difference <= 0) return "0 Day(s) 0 Hour(s) 0 Min(s)"

    const days = Math.floor(difference / (1000 * 60 * 60 * 24))
    const hours = Math.floor(
      (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    )
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))

    return `${days} Day(s) ${hours} Hour(s) ${minutes} Min(s)`
  }

  const timeLeft = cancelBookingData?.departure_date
    ? calculateTimeLeft(cancelBookingData.departure_date)
    : "Calculating..."

  const handleTransferClick = () => {
    setShowTransferConfirmation(true)
  }

  const confirmTransfer = () => {
    setShowTransferConfirmation(false)
    HandleA2ZApiTransfer()
  }

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <Loader />
        </div>
      ) : (
        <>
          <Card style={{ fontSize: "11px" }}>
            {transferA2z && cancelBookingData?.company?.cancellation_status ? (
              <>
                <ModalBody>
                  <Row>
                    <Col md={7}>
                      <h5>Api Transfer</h5>
                      <p>
                        <strong>Transfer Id:</strong>
                        <p> {apiResponse?.map(t => t.id).join(" ")}</p>
                      </p>
                    </Col>
                    <Col md={5} className=" f-11 ">
                      <h6 className="fw-bold">Transfer Amount:</h6>
                      <h5 className="text-center fw-bold">
                        £{(totalAmount / 100).toFixed(2)}
                      </h5>
                    </Col>
                  </Row>
                  <Col md={6} className="d-flex align-items-start mt-2">
                    <Button
                      color={approveA2z ? "primary" : "success"}
                      className="f-11"
                      onClick={handleTransferClick}
                      disabled={!approveA2z}
                    >
                      {btnLoading ? "Loading..." : "Reverse Transfer Amount"}
                    </Button>
                  </Col>
                </ModalBody>
              </>
            ) : (
              ""
            )}
            <ModalBody>
              <div>
                <h6 style={{ fontWeight: "600" }}> Cancel Booking</h6>
              </div>

              {cancelBookingData?.company?.cancellation_status ? (
                <div
                  style={{
                    backgroundColor: "#EAEBF2",
                    padding: "10px",
                    borderRadius: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <p>
                    <strong>
                      This Is Flex-able Booking with No Cancellation Cover.
                    </strong>
                  </p>
                  <p>
                    Time Left in Vehicle Drop-off: <strong>{timeLeft}</strong>
                  </p>
                  <p>
                    Payment Gateway:{" "}
                    <strong style={{ textTransform: "capitalize" }}>
                      {cancelBookingData?.payment?.type}
                    </strong>
                  </p>
                  <p>Select Below Option(s) To Handle Cancellation Request.</p>
                </div>
              ) : (
                <div
                  style={{
                    backgroundColor: "#EAEBF2",
                    padding: "10px",
                    borderRadius: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <p>
                    <strong className="text-danger">
                      {" "}
                      This is a Non-Flex Booking
                    </strong>
                  </p>
                  <p>
                    Be Advised: As Per Terms & Conditions Section 4 4.6,{" "}
                    <strong className="text-danger">
                      {" "}
                      This Booking Cannot be Cancelled.
                    </strong>
                  </p>
                  <p>Time Left in Vehicle Drop-off {timeLeft}</p>
                  <p>
                    Payment Gateway:{" "}
                    <strong style={{ textTransform: "capitalize" }}>
                      {cancelBookingData?.payment?.type}
                    </strong>
                  </p>
                  <p>Select Below Option(s) To Handle Cancellation Request.</p>
                </div>
              )}

              {cancelBookingData?.company?.cancellation_status ? (
                <Form>
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="paidAmount" style={{ fontSize: "11px" }}>
                          Paid Amount *
                        </Label>
                        <Input
                          type="text"
                          name="paidAmount"
                          id="paidAmount"
                          value={(
                            (parseFloat(cancelBookingData?.payment?.amount) ||
                              0) +
                            (parseFloat(
                              cancelBookingData?.payment?.cancellation_charges
                            ) || 0) +
                            (parseFloat(
                              cancelBookingData?.payment?.sms_charges
                            ) || 0) +
                            (parseFloat(
                              cancelBookingData?.payment?.levy_charges
                            ) || 0) +
                            (parseFloat(
                              cancelBookingData?.payment?.valet_charges
                            ) || 0) +
                            (parseFloat(
                              cancelBookingData?.payment?.admin_charges
                            ) || 0) +
                            (parseFloat(
                              cancelBookingData?.payment?.extra_charges
                            ) || 0) -
                            (parseFloat(cancelBookingData?.payment?.discount) ||
                              0)
                          ).toFixed(2)}
                          readOnly
                          className="border-secondary"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={8}>
                      <FormGroup>
                        <Label style={{ fontSize: "11px" }}>
                          Refund Amount / Difference *
                        </Label>
                        <Row className="g-0">
                          <Col md={6}>
                            <Input
                              type="text"
                              name="refundAmount"
                              id="refundAmount"
                              value={refundAmount.toFixed(2)}
                              readOnly
                              style={{
                                borderTopRightRadius: 0,
                                borderBottomRightRadius: 0,
                              }}
                              className="border-secondary"
                            />
                          </Col>
                          <Col md={6}>
                            <Input
                              type="text"
                              name="differenceAmount"
                              id="differenceAmount"
                              value={differenceAmount}
                              // onChange={e => {
                              //   const value = parseFloat(e.target.value) || 0
                              //   setDifferenceAmount(value < 0 ? 0 : value)
                              // }}
                              onChange={e => {
                                const value = e.target.value;
                                if (/^\d*\.?\d*$/.test(value) || value === "") {
                                  setDifferenceAmount(value < 0 ? 0 : value)
                                }
                              }}
                              style={{
                                borderTopLeftRadius: 0,
                                borderBottomLeftRadius: 0,
                                borderLeft: "none",
                              }}
                              className="border-secondary"
                            />
                          </Col>
                        </Row>
                      </FormGroup>
                    </Col>
                  </Row>

                  <FormGroup>
                    <Label for="refundOption" style={{ fontSize: "11px" }}>
                      Select Refund Option *
                    </Label>
                    <Input
                      type="select"
                      name="refundOption"
                      id="refundOption"
                      className="border-secondary"
                      onChange={e => setRefundOption(e.target.value)}
                      style={{ fontSize: "11px" }}
                    >
                      <option value="">Select Refund Option</option>
                    {cancelBookingData?.payment?.type != "worldpay" &&   <option value="Refund">Refund</option>}
                      <option value="No Refund">No Refund</option>
                    </Input>
                  </FormGroup>

                  <FormGroup>
                    <Label for="actionNote" style={{ fontSize: "11px" }}>
                      Action Note
                    </Label>
                    <Input
                      type="textarea"
                      name="actionNote"
                      id="actionNote"
                      placeholder="Add Note (if any) To Track Reason of Action in Future"
                      className="border-secondary"
                      onChange={e => setInstructions(e.target.value)}
                      style={{ fontSize: "11px" }}
                    />
                  </FormGroup>
                  <Row>
                    <Col md={6}>
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            className="border-primary"
                            name="customer_email"
                            checked={
                              checkbox?.customer_email == "1" ? true : false
                            }
                            onClick={handleCheckboxChange}
                            style={{ fontSize: "11px" }}
                          />{" "}
                          Send Customer Email
                        </Label>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            className="border-primary"
                            name="company_email"
                            checked={
                              checkbox?.company_email == "1" ? true : false
                            }
                            onClick={handleCheckboxChange}
                            style={{ fontSize: "11px" }}
                          />{" "}
                          Send Company Email
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Button
                    color="warning"
                    size="sm me-3"
                    disabled={approveA2z}
                    onClick={handleSubmit}
                  >
                    Submit Request
                  </Button>
                  <Button
                    color="secondary"
                    size="sm"
                    onClick={() => setActiveTab("")}
                  >
                    Close
                  </Button>
                </Form>
              ) : (
                <Button
                  color="secondary"
                  size="sm"
                  onClick={() => setActiveTab("")}
                >
                  Close
                </Button>
              )}
            </ModalBody>
          </Card>
          {showConfirmation && (
            <Modal isOpen={showConfirmation} toggle={setShowConfirmation}>
              <ModalHeader toggle={toggle}>Confirm Cancellation</ModalHeader>
              <ModalBody>Are you sure you wanna cancel this booking?</ModalBody>
              <ModalFooter>
                <Button color="danger" onClick={confirmCancellation}       disabled={modalBtnLoader} style={{
                  width: "120px"
                }}>
                  {modalBtnLoader ? (
                    <div
                      className="spinner-border text-light spinner-border-sm"
                      role="status"
                
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    "Yes, Cancel"
                  )}
                </Button>
                <Button
                  color="secondary"
                  onClick={() => setShowConfirmation(false)}
                >
                  No, Go Back
                </Button>
              </ModalFooter>
            </Modal>
          )}
          <Modal
            isOpen={showTransferConfirmation}
            toggle={() => setShowTransferConfirmation(false)}
          >
            <ModalHeader toggle={() => setShowTransferConfirmation(false)}>
              Confirm Transfer
            </ModalHeader>
            <ModalBody>Are you sure you want to transfer the amount?</ModalBody>
            <ModalFooter>
              <Button
                color="danger"
                onClick={() => setShowTransferConfirmation(false)}
              >
                Cancel
              </Button>
              <Button color="success" onClick={confirmTransfer}>
                Confirm
              </Button>
            </ModalFooter>
          </Modal>
        </>
      )}
    </>
  )
}

export default CancelBookingModal
